import {
  createWatchListAsyncThunk,
  deleteWatchListAsyncThunk,
  fetchWatchLists,
  getProductAsyncThunk,
  renameWatchlistAsyncThunk,
  setWatchlistName,
} from "../../../store/slices/watchlist/data.slice";
import {
  createWatchList,
  getProduct,
} from "../../../store/slices/watchlist/data.thunk";
import Header from "../../elements/Header";
import WatchlistCategory from "../../elements/WatchlistCategory";
import DropDown from "../../elements/Dropdown";
import styles from "./index.module.css";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import BeatLoader from "react-spinners/BeatLoader";
import { sortingSteps, sortingMapping } from '../../../utils/constant'

const DfWatchlist = (props) => {
  const dispatch = useDispatch();
  const loadOnce = useRef(true);
  const previousSource = useRef(null);
  const { watchLists, loading, error } = useSelector(
    (store) => store.watchlist
  );
  const { source } = useSelector((store) => store.constant);
  const [activeTab, setActiveTab] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [sorting, setSorting] = useState(0);

  const extendedSortingSteps = ["A to Z", "Z to A", ...sortingSteps];
  const extendedSortingMapping = {
    ...sortingMapping,
    "A to Z": "A_to_Z",
    "Z to A": "Z_to_A",
  };

  const updatedSortingKeys = extendedSortingSteps.map(label => extendedSortingMapping[label]);

  console.log(updatedSortingKeys)

  const onSortingChange = (value, index) => {
    setSorting(index);
    // Trigger API call with new sort parameter
    if (watchLists[activeTab]?.watchlist_id) {
      dispatch(
        getProductAsyncThunk({
          watchlist_id: watchLists[activeTab].watchlist_id,
          source,
          sort: updatedSortingKeys[index],
        })
      );
    }
  };

  const refreshProducts = () => {
    if (watchLists[activeTab]?.watchlist_id) {
      dispatch(
        getProductAsyncThunk({
          watchlist_id: watchLists[activeTab].watchlist_id,
          source,
          sort: updatedSortingKeys[sorting],
        })
      );
    }
  };

  const getWatchLists = () => {
    if (watchLists.length == 0) {
      dispatch(fetchWatchLists());
    }
  };
  useEffect(() => {
    getWatchLists();
  }, []);

  useEffect(() => {
    if (watchLists.length > 0 && loadOnce.current) {
      dispatch(
        getProductAsyncThunk({
          watchlist_id: watchLists[0].watchlist_id,
          source,
          sort: updatedSortingKeys[sorting],
        })
      );
      loadOnce.current = false;
    }
  }, [watchLists, dispatch, sorting]);

  // Refetch data when source changes
  useEffect(() => {
    // Only refetch if source actually changed and we have a watchlist
    if (
      previousSource.current !== null &&
      previousSource.current !== source &&
      watchLists.length > 0 &&
      watchLists[activeTab]?.watchlist_id
    ) {
      console.log('Source changed from', previousSource.current, 'to', source, '- refetching data');
      dispatch(
        getProductAsyncThunk({
          watchlist_id: watchLists[activeTab].watchlist_id,
          source,
          sort: updatedSortingKeys[sorting],
        })
      );
    }
    // Update the previous source
    previousSource.current = source;
  }, [source, watchLists, activeTab, dispatch, sorting]);

  const handleCreateWatchlist = () => {
    dispatch(createWatchListAsyncThunk("New Watchlist"));
  };

  const addTabHandler = () => {
    handleCreateWatchlist();
  };

  const changeActiveTab = (e) => {
    setIsEdit(false);
    setActiveTab(e?.target?.dataset?.idx);
    dispatch(
      getProductAsyncThunk({
        watchlist_id: e?.target?.dataset?.watchlist_id,
        source,
        sort: updatedSortingKeys[sorting],
      })
    );
  };

  const handleDeleteWatchlist = (id) => {
    dispatch(deleteWatchListAsyncThunk(id));
  };

  const deleteTab = () => {
    handleDeleteWatchlist(watchLists[Number(activeTab)].watchlist_id);
    setActiveTab(0);
  };

  const handleEditWatchlistName = (e) => {
    dispatch(
      setWatchlistName({
        index: activeTab,
        value: e.target.value,
      })
    );
  };

  const editTitle = () => {
    setIsEdit(false);
    dispatch(
      renameWatchlistAsyncThunk({
        name: watchLists[activeTab].watchlist_name,
        watchlist_id: watchLists[Number(activeTab)].watchlist_id,
      })
    );
  };

  const handleEditEnter = (e) => {
    if (e.key == "Enter") {
      editTitle();
    }
  };

  return (
    <div className={styles["container"]}>
      <Header />
      <hr />

      <div className={styles["tab_container"]}>
        <div className={styles["tab_content"]}>
          {watchLists.length > 0 &&
            watchLists?.map((tab, idx) => (
              <div
                className={
                  activeTab == idx
                    ? styles["tab"] + " " + styles["active"]
                    : styles["tab"]
                }
                onClick={changeActiveTab}
                data-idx={idx}
                data-watchlist_id={tab.watchlist_id}
              >
                {tab?.watchlist_name}
              </div>
            ))}
          <div className={styles["tab_cta"]} onClick={addTabHandler}>
            <i class="bi bi-plus"></i>
          </div>
        </div>
      </div>
      <hr />

      {watchLists.length > 0 && (
        <WatchlistCategory
          category={watchLists[activeTab].category}
          watchlist_id={watchLists[activeTab].watchlist_id}
          deleteTab={deleteTab}
          products={watchLists[activeTab]?.products || []}
          setIsEdit={setIsEdit}
          onProductDeleted={refreshProducts}
          sorting={sorting}
          onSortingChange={onSortingChange}
          sortingSteps={extendedSortingSteps}
        >
          {isEdit ? (
            <div className={styles["editWatchlist"]}>
              <input
                type="text"
                value={watchLists[activeTab].watchlist_name}
                onChange={handleEditWatchlistName}
                className={styles["editWatchlistTitle"]}
                maxLength="45"
                onKeyDown={handleEditEnter}
              />
              <button onClick={editTitle}>Save</button>
            </div>
          ) : (
            watchLists[activeTab].watchlist_name
          )}
        </WatchlistCategory>
      )}
    </div>
  );
};

export default DfWatchlist;
